module.exports = __webpack_public_path__ + "static/img/default-cerfity-img.6cf0bfcd.jpg";